<template>
  <div class="EleSection">
    <section v-if="formItem.type == 'SelectUser'">
      <SelectUser
        v-model="form[formItem.param]"
        :multiple="formItem.multiple || false"
        :styleData="formItem.styleData"
        :placeholder="formItem.placeholder"
        :isMyShow="!!formItem.isMyShow">
      </SelectUser>
    </section>
    <!-- 输入框 -->
    <section v-if="formItem.type == 'Input'">
      <el-input
        v-model="form[formItem.param]"
        clearable
        :placeholder="
          formItem.placeholder ? formItem.placeholder : '请输入内容'
        "
        :size="formItem.size"
        :disabled="formItem.disabled"
        :maxlength="formItem.maxLength"
        :minlength="formItem.minLength"
        :name="formItem.name"
        @input="handleChangeInput"
        @blur="handleInputBlur"
      >
        <template v-if="formItem.unit" slot="append">{{
          formItem.unit
        }}</template>
      </el-input>
    </section>
    <!-- 多行输入框 -->
    <section v-if="formItem.type == 'Textarea'">
      <el-input
        v-model="form[formItem.param]"
        :maxlength="formItem.maxLength"
        type="textarea"
        :rows="4"
        :size="formItem.size"
        :placeholder="TextareaPlaceholder"
        :disabled="formItem.disabled"
        show-word-limit
        @input="handleChangeInput"
        @blur="handleInputBlur"
      />
      <span>{{ formItem.remake }}</span>
    </section>
    <!-- 单选按钮 -->
    <section v-if="formItem.type == 'Radio'">
      <el-radio-group
        v-model="form[formItem.param]"
        @change="handleRadioChange(formItem)"
      >
        <el-radio
          v-for="item in formItem.options"
          :key="item.value + 'Radio'"
          :disabled="formItem.disabled"
          :label="item.value"
          >{{ item.label }}</el-radio
        >
      </el-radio-group>
    </section>
    <!-- 多选按钮 -->
    <section v-if="formItem.type == 'Checkbox'">
      <el-checkbox
        v-if="!formItem.options"
        v-model="form[formItem.param]"
        :true-label="formItem.trueLabel"
        :false-label="formItem.falseLabel"
        :border="formItem.border"
        :label="formItem.labelName"
      />
      <el-checkbox-group v-else v-model="form[formItem.param]">
        <el-checkbox
          v-for="item in formItem.options"
          :key="item.value + 'Checkbox'"
          :label="item.value"
        />
      </el-checkbox-group>
    </section>
    <!-- 单选按钮 +多选 -->
    <section v-if="formItem.type == 'RadioCheckbox'">
      <el-radio-group v-model="form[formItem.param]">
        <el-radio
          v-for="item in formItem.options"
          :key="item.value + 'Radiocheckbox'"
          :label="item.value"
          :value="item.label"
          >{{ item.label }}</el-radio
        >
      </el-radio-group>
      <el-checkbox
        v-for="item in formItem.options2"
        v-show="!item.hide &&
          form[formItem.param] == formItem.selectVisible &&
          !formItem.checkboxFlag
        "
        :key="item.value + 'radioCheckbox'"
        v-model="form[formItem.param2]"
        style="padding-left: 40px"
        :true-label="item.value"
        :false-label="Number(item.value2) || air"
        :label="item.value"
        >{{ item.label }}</el-checkbox
      >
    </section>
    <!-- 选择框 -->
    <section v-if="formItem.type == 'Select'">
      <el-select
        v-model="form[formItem.param]"
        :disabled="CascaderDisabled"
        clearable
        filterable
        :default-first-option="true"
        :multiple="formItem.dataType === 'Array'"
        :props="formItem.props || selectProps"
        :placeholder="formItem.placeholder ? formItem.placeholder : '请选择'"
        :size="formItem.size"
        :style="formItem.componentStyle"
        @focus="handleSelectfocus"
        @change="handleChangeSelect($event,formItem.param)"
      >
        <el-option
          v-for="item in formItem.options"
          :key="item[formItem.key || 'value']"
          :label="item[formItem.label || 'label']"
          :value="item[formItem.value || 'value']"
          :disabled="item[formItem.disabled || 'disabled']"
        />
      </el-select>
    </section>

     <!-- 选择框 -->
    <section v-if="formItem.type == 'SelectDisabled'">
      <!--
        :filter-method="pinyingMatch"

       -->
      <el-select
        v-model="form[formItem.param]"
        :disabled="formItem.disabled"
        clearable
        filterable
        :default-first-option="true"
        :multiple="formItem.dataType == Array"
        :props="formItem.props || selectProps"
        placeholder="请选择"
        :size="formItem.size"
        :style="formItem.componentStyle"
        @focus="handleSelectfocus"
        @change="handleChangeSelect($event,formItem.param)"
      >
        <el-option
          v-for="item in formItem.options"
          :key="item[formItem.key || 'value']"
          :label="item[formItem.label || 'label']"
          :value="item[formItem.value || 'value']"
        />
      </el-select>
    </section>

    <!-- 选择框 -->
    <section v-if="formItem.type == 'SelectMultiple'">
      <el-select
        v-model="form[formItem.param]"
        :disabled="CascaderDisabled"
        clearable
        filterable
        :default-first-option="true"
        :multiple="formItem.multiple"
        :props="formItem.props || selectProps"
        placeholder="请选择"
        :size="formItem.size"
        :style="formItem.componentStyle"
        @focus="handleSelectfocus"
        @change="handleChangeSelect($event,formItem.param)"
      >
        <el-option
          v-for="item in formItem.options"
          :key="item[formItem.key || 'value']"
          :label="item[formItem.label || 'label']"
          :value="item[formItem.value || 'value']"
        />
      </el-select>
    </section>
    <!-- 选择框 -->
    <section v-if="formItem.type == 'SelectRemote'">
      <el-select
        v-model="form[formItem.param]"
        :disabled="CascaderDisabled"
        filterable
        remote
        clearable
        placeholder="请输入关键词"
        :remote-method="remoteMethod"
        :loading="form[formItem.loading]"
        :size="formItem.size"
        :style="formItem.componentStyle"
      >
        <el-option
          v-for="item in formItem.options"
          :key="item[formItem.key || 'value']"
          :label="item[formItem.label || 'label']"
          :value="item[formItem.value || 'value']"
        />
      </el-select>
    </section>
    <!-- 树形下拉框 -->
    <section v-if="formItem.type == 'Tree'">
      <el-tree
        v-model="form[formItem.param]"
        :data="formItem.options"
        :props="formItem.defaultProps"
        :accordion="formItem.accordion"
      >
      </el-tree>
    </section>
    <!-- 树形选择框 -->
    <section v-if="formItem.type == 'SelectTree'">
      <el-select
        :placeholder="formItem.placeholder"
        :multiple="formItem.checkbox"
        v-model="form[formItem.param]"
        @change="selectTreeChange"
        :value="treeValue"
        :collapse-tags="formItem.collapseTags"
        :clearable="formItem.clearable"
        :size="formItem.size"
      >
        <el-option
          ref="opt"
          class="options"
          :value="treeValue"
          style="height: auto; padding: 0"
        >
          <el-tree
            id="tree-option"
            :ref="'selectTree'"
            node-key="id"
            :show-checkbox="formItem.checkbox"
            :accordion="formItem.accordion"
            :data="formItem.options"
            :check-strictly="formItem.checkStrictly"
            :props="formItem.defaultProps"
            @node-click="handleNodeClick"
            highlight-current
            @check-change="handleTreeCheckChange('SelectTree', $event)"
          />
        </el-option>
      </el-select>
    </section>
    <!-- 日期选择器 -->
    <section v-if="formItem.type == 'DataPickerOptions'">
      <el-date-picker
        v-model="form[formItem.param]"
        align="right"
        type="date"
        :size="formItem.size"
        :value-format="formItem.format"
        placeholder="选择日期"
        :picker-options="dataPickerOptions"
      />
    </section>
    <!-- 时间日期选择 -->
    <section v-if="formItem.type == 'DateTimePicker'">
      <el-date-picker
        v-model="form[formItem.param]"
        type="datetimerange"
        :size="formItem.size"
        :picker-options="pickerOptions"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      />
    </section>
    <!-- 时间日期选择  限制选择时间范围 -->
    <section v-if="formItem.type == 'RestrictDateTimePicker'">
      <el-date-picker
        v-model="form[formItem.param]"
        type="datetimerange"
        :size="formItem.size"
        :picker-options="restrictPickerOptions"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      />
    </section>
    <!-- 时间选择 全封装 -->
    <section v-if="formItem.type == 'DataType'">
      <el-date-picker
        v-model="form[formItem.param]"
        :type="formItem.dataType"
        :size="formItem.size"
        :picker-options="restrictPickerOptions"
        :value-format="formItem.valueFormat"
        :format="formItem.format"
        :range-separator="formItem.rangeSeparator"
        :start-placeholder="formItem.startPlaceholder"
        :end-placeholder="formItem.endPlaceholder"
        :placeholder="formItem.placeholder"
      />
    </section>
    <!-- 开关 -->
    <section v-if="formItem.type == 'Switch'">
      <div class="el_content">
        <el-switch v-model="form[formItem.param]" />
        <span>取消订单</span>
      </div>
    </section>

    <!-- 开关 -->
    <section v-if="formItem.type == 'SwitchForm'">
      <!-- <div class="el_content"> -->
        <el-switch v-model="form[formItem.param]"
          :active-color="formItem.activeColor"
          :inactive-color="formItem.inactiveColor"
          :active-value="formItem.activeValue"
          :inactive-value="formItem.inactiveValue"
        />
      <!-- </div> -->
    </section>

    <!-- 级联选择框 -->
    <section v-if="formItem.type == 'Cascader'">
      <el-cascader
        :key="formItem.key + 'Cascader'"
        :ref="formItem.param + 'Cascader'"
        v-model="form[formItem.param]"
        clearable
        :size="formItem.size"
        :disabled="CascaderDisabled"
        :placeholder="'请选择'"
        :options="formItem.options || []"
        :props="formItem.props || cascaderProps"
        filterable
        @change="handleChangeCascader(formItem.param + 'Cascader', $event,formItem.param)"
      />
    </section>

    <!-- img -->
    <section v-if="formItem.type == 'ImgText'" class="ImgText">
      <a
        v-for="item in formItem.data"
        :key="item.name + 'ImgText'"
        style="
          color: rgb(24, 144, 255);
          cursor: pointer;
          text-decoration: underline;
        "
        target="_blank"
        :href="item.url"
        >{{ item.name }}</a
      >
    </section>

    <!-- 只读 -->
    <section v-if="formItem.type == 'Text'" class="Text">
      <span :style="formItem.style" @click="formItem.handle(formItem.row)">
        {{
          formItem.data === "" ||
          formItem.data === null ||
          formItem.data === undefined
            ? "--"
            : formItem.data + (formItem.unit ? formItem.unit : "")
        }}
      </span>
      <span v-if="formItem.default !== undefined" class="default">{{
        formItem.default + (formItem.unit ? formItem.unit : "")
      }}</span>
    </section>
    <!-- 只读 a 链接 -->
    <section v-if="formItem.type == 'AText'" class="Text">
      <div :style="formItem.style">
        <a :href="formItem.data" target="_blank">
          {{
            formItem.data === "" ||
            formItem.data === null ||
            formItem.data === undefined
              ? "--"
              : formItem.text
          }}
        </a>
      </div>
    </section>
    <!-- 按钮只读事件 -->
    <section v-if="formItem.type == 'Button'">
      <div :style="formItem.style">
        <a @click="incident">
          {{ formItem.text }}
        </a>
      </div>
    </section>
    <!-- 只读 -->
    <section v-if="formItem.type == 'TextCheckbox'" class="TextCheckbox">
      <span>
        {{
          formItem.data === "" ||
          formItem.data === null ||
          formItem.data === undefined
            ? "--"
            : formItem.data + (formItem.unit ? formItem.unit : "")
        }}
      </span>
      <el-checkbox
        v-for="item in formItem.options2"
        v-show="form[formItem.param] == formItem.selectVisible"
        :key="item.value + 'TextCheckbox'"
        v-model="form[formItem.param2]"
        style="padding-left: 40px"
        :true-label="item.value"
        :false-label="Number(item.value2) || air"
        :label="item.value"
        >{{ item.label }}</el-checkbox
      >
    </section>
    <!-- 复合型输入框， 修改值-默认值 -->
    <section v-if="formItem.type == 'InputTextView'">
      <div class="InputTextView">
        <el-input
          v-model="form[formItem.param]"
          :placeholder="formItem.placeholder || '请输入内容'"
          :disabled="formItem.disabled"
          @input="handleChangeInput"
          @blur="handleInputBlur"
        >
          <template slot="append">{{ formItem.unit }}</template>
        </el-input>
        <span class="default">{{ formItem.default + formItem.unit }}</span>
      </div>
    </section>

    <!-- 上传类型限制 -->
    <section v-if="formItem.type == 'RestrictUpload'" class="uploads">
      <el-upload
        v-model="form[formItem.param]"
        class="upload-demo"
        drag
        action=""
        multiple
        :accept="formItem.accept"
        :before-upload="beforeAvatarUpload"
        :on-remove="handleRemoveImgList"
        :file-list="form[formItem.param]"
        :limit="formItem.limit"
        :on-exceed="handleRestrictExceed"
        :http-request="handleRestrictUpload"
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">{{ formItem.uploadRemake }}</div>
      </el-upload>
    </section>
    <!-- 图片上传 1张 -->
    <section v-if="formItem.type == 'Upload'" class="upload">
      <el-upload
        ref="upload1"
        class="avatar-uploader"
        action=""
        :show-file-list="false"
        accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.GIF"
        :http-request="imgUpload"
        @click.native="fileChange(1, 'id_card_before_url')"
      >
        <img
          v-if="form[formItem.param]"
          :src="form[formItem.param]"
          class="avatar"
        />
        <i v-else class="el-icon-plus avatar-uploader-icon" />
      </el-upload>
      <p>
        <span>将图片拖到此处，或者点击+上传附件</span>
        <span> 图片大小应小于10M</span>
      </p>
    </section>

    <!-- 图片上传 多张-->
    <section v-if="formItem.type == 'Uploads'" class="uploads">
      <el-upload
        v-model="form[formItem.param]"
        class="upload-demo"
        drag
        action=""
        multiple
        :accept="formItem.accept"
        :before-upload="beforeAvatarUpload"
        :on-remove="handleRemoveImgList"
        :file-list="form[formItem.param]"
        :limit="formItem.limit ? formItem.limit : 5"
        :on-exceed="handleExceed"
        :http-request="imgUpload"
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">{{ formItem.uploadRemake }}</div>
      </el-upload>
    </section>
    <!-- 图片上传 多张-->
    <section v-if="formItem.type == 'LocalUploads'" class="uploads">
      <el-upload
        v-model="form[formItem.param]"
        class="upload-demo"
        drag
        action=""
        multiple
        :before-upload="beforeAvatarUpload"
        :on-remove="handleRemoveImgList"
        :file-list="form[formItem.param]"
        :limit="5"
        :on-exceed="handleExceed"
        :http-request="localImgUpload"
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">{{ formItem.uploadRemake }}</div>
      </el-upload>
    </section>

    <!-- 文本显示 -->
    <section v-if="formItem.type == 'SideWords'" class="side_words">
      <div :style="formItem.style">{{ formItem.data }}</div>
    </section>
    <!-- 分割线 -->
    <section v-if="formItem.type == 'Divider'" class="divider">
      <el-divider />
    </section>
    <!-- 表单操作 -->
    <section
      v-if="formKey == 'edit'"
      class="edit"
      :class="formItem.align == 'center' ? 'center' : ''"
    >
      <!-- v-for="(item, key, index) in formItem.handle" -->

      <el-button
        v-for="(item, key) in (formItem.handle ? formItem.handle : [])"
        :key="key"
        :disabled="item.disabled"
        :type="key == 'submit' ? 'primary' : ''"
        @click="
          key == 'submit'
            ? submit()
            : key == 'reset'
            ? reset()
            : key == 'submitExtensionOne'
            ? submitExtensionOne()
            : key == 'submitExtensionTwo'
            ? submitExtensionTwo()
            : null
        "
        >{{ item.buttonText }}</el-button
      >
    </section>
    <section v-if="formItem.type == 'InputIcon'">
      <el-tooltip
        class="item"
        effect="light"
        :content="formItem.content"
        placement="top-start"
      >
        <i
          style="position: absolute; left: -14px"
          class="el-icon-warning-outline"
        ></i>
      </el-tooltip>
      <el-input
       v-model="form[formItem.param]"
        clearable
        :placeholder="
          formItem.placeholder ? formItem.placeholder : '请输入内容'
        "
        :size="formItem.size"
        :disabled="formItem.disabled"
        :maxlength="formItem.maxLength"
        :minlength="formItem.minLength"
        @input="handleChangeInput"
        @blur="handleInputBlur"
      >
        <template v-if="formItem.unit" slot="append">{{
          formItem.unit
        }}</template>
      </el-input>
    </section>
    <section v-if="formItem.type == 'ClickButton'">
      <el-button
        v-for="item in formItem.options"
        :key="item.value"
        v-bind="item"
        @click="handleClickButton(item.value)"
      >
        {{ item.label }}
      </el-button>
    </section>
  </div>
</template>
<script>
import SelectUser from '@/components/SelectUser'
import axios from "axios";
import { getOss, getOcr } from "@/api/car";
import { parseTime } from "@/utils/index";
import { randomString } from "@/utils/random";
import { localUpload } from "@/api/work-order/accept-order";

const curtime = parseTime(new Date()).split(" ")[0].split("-");

export default {
  components: {
    SelectUser
  },
  props: {
    //  总form渲染列表
    formOptions: {
      type: Object,
      default: () => {},
    },
    form: {
      type: Object,
      default: () => [],
    },
    formItem: {
      type: Object,
      default: () => {
      },
    },
    formKey: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "",
    },
    submit: {
      type: Function,
      default: () => {},
    },
    reset: {
      type: Function,
      default: () => {},
    },
    // 扩展，可以为其他函数
    submitExtensionOne: {
      type: Function,
      default: () => {},
    },
    // 扩展二
    submitExtensionTwo: {
      type: Function,
      default: () => {},
    },
    // 输入框失去焦点事件
    inputBlur: {
      type: Function,
      default: () => {},
    },
    // 选择框失去焦点事件
    selectChange: {
      type: Function,
      default: () => {},
    },
    // 单选框change事件
    radioChange: {
      type: Function,
      default: () => {},
    },
    // 级联change事件
    cascaderChange: {
      type: Function,
      default: () => {},
    },
    cascaderDisabledHandle: {
      type: Function,
      default: () => {},
    },
    remoteMethod: {
      type: Function,
      default: () => {},
    },
    incident: {
      type: Function,
      default: () => {},
    },
    clickButtonChange: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      cascaderKey: "",
      air: "",
      cascaderProps: {
        value: "id",
        label: "label_name",
      },
      selectProps: {
        value: "value",
        label: "label",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      restrictPickerOptions: {
        disabledDate: (time) => {
          let nowDate = this.formItem?.nowDate;
          let restrictTimeLength = this.formItem?.restrictTimeLength;
          let restrictDays = nowDate - restrictTimeLength;
          return time.getTime() > nowDate || time.getTime() < restrictDays;
        },
        onPick: (val) => {
          const startTime = val?.minDate?.getTime();
          const endTime = val?.maxDate?.getTime();
          if (
            endTime - startTime >
            this.formItem?.restrictDays * 24 * 3600 * 1000
          ) {
            this.$message({
              message: "最多选择" + this.formItem?.restrictDays + "天",
              type: "error",
            });
          }
        },
      },
      dataPickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > this.formItem?.nowDate;
        },
        ...this.formItem?.dataPickerOptions ?? {}
      },
      ossParms: {},
      photoUrls: [],
      photoUrlData: [],
      options: [],
      treeValue: [],
    };
  },
  created() {
    if (!this.formItem.size) {
      this.formItem.size = "mini";
    }
  },
  computed: {
    CascaderDisabled() {
      const list = this.formItem.disabled;
      if (typeof this.formItem.disabled == "boolean") return true;

      if (list) {
        for (const i in list) {
          if (!this.form[list[i]]) return true;
        }
      }

      // if (this.CascaderDisabledHandle) this.CascaderDisabledHandle()
      return false;
    },
    TextareaPlaceholder() {
      if (this.formItem.maxLength) {
        return `最大可填写${this.formItem.maxLength}字`;
      }
      if (this.formItem.minLength) {
        return `最少填写${this.formItem.minLength}字`;
      }
      return "请输入内容";
    },
  },
  watch: {
    formItem: {
      handler(val) {
        if (this.formItem.type == "Cascader") {
          // ++this.formItem.key
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (
      this.formItem.type === "Uploads" ||
      this.formItem.type === "RestrictUpload"
    ) {
      this.getOssToken();
    }
  },
  methods: {
    handleInputBlur(e) {
      if (this.formItem.dataType == "Number") {
        this.form[this.formItem.param] = this.form[this.formItem.param]
          ? Number(this.form[this.formItem.param])
          : this.form[this.formItem.param];
      }
      if (this.formItem.blur) {
        this.inputBlur(e,this.formItem.param);
      }
      if (this.formItem.dataType == "Number") {
        if (typeof this.formItem.min == "number") {
          this.form[this.formItem.param] =
            this.form[this.formItem.param] >= this.formItem.min
              ? this.form[this.formItem.param]
              : this.formItem.min;
        }
      }
    },
    handleChangeInput(val) {
      if (this.formItem.dataType == "Number") {
        if (!val) return;
        this.form[this.formItem.param] = val
          .replace(/[^\-?\d.]/g, "")
          .replace(/^\./g, "")
          .replace(".", "$#$")
          .replace(/\./g, "")
          .replace("$#$", ".")
          .replace("-", "$#$")
          .replace(/\-/g, "")
          .replace("$#$", "-")
          // 输入两位小数
          .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");

        if (typeof this.formItem.max == "number") {
          this.form[this.formItem.param] =
            this.form[this.formItem.param] <= this.formItem.max
              ? this.form[this.formItem.param]
              : this.formItem.max;
        }
      }
    },
    // 点击按钮事件
    handleClickButton(val) {
      this.clickButtonChange(val, this.formItem.param);
    },

    // 单选框Change事件
    handleRadioChange(val) {
      this.radioChange(this.form[val.param], val.param);
    },
    handleSelectfocus() {
      if (!this.formItem.defaultOptions) {
        this.formItem.defaultOptions = this.formItem.options;
      }
      this.formItem.options =
        this.formItem.defaultOptions || this.formItem.options;
    },

    // 拼音筛选（部分选择问题待解决，未使用）
    pinyingMatch(val) {
      try {
        var that = this;
        if (!that.formItem.defaultOptions && !that.formItem.defaultOptions) {
          return;
        }
        const pinyingMatch = require("pinyin-match");
        if (val) {
          var result = [];
          // 注意otherList是内容数组，根据自己项目修改
          that.formItem.defaultOptions.forEach((e) => {
            // 注意，e.employeeName是遍历数组之后的键，按需修改
            var m = pinyingMatch.match(e[that.formItem.label || "label"], val);

            if (m) {
              result.push(e);
            }
          });
          // 搜索到相应的数据就把符合条件的n个数据赋值brand
          that.formItem.options = result;
        } else {
          // 没有搜索到数据，就还展示所有的brand
          // copyotherList也是内容数组，为了显示全部，需要添加进之前的内容
          that.formItem.options = that.formItem.defaultOptions;
        }
      } catch (e) {
        return;
      }
    },
    // 下拉框 Change事件
    handleChangeSelect(val,paramkey) {
      if (this.formItem.Related) {
        // 只关联一个数据
        if (typeof this.formItem.Related == "string") {
          if (val) {
            const searchIndex = this.formItem.options.findIndex(
              (n) => n[this.formItem.value] === val
            );
            this.form[this.formItem.Related] =
              this.formItem.options[searchIndex][this.formItem.RelatedName];
          } else {
            this.form[this.formItem.Related] = "";
          }
        } else {
          if (!val) {
            this.form[this.formItem.Related] = "";
            return;
          }
          for (const item in this.formItem.Related) {
            const name = this.formItem.Related[item].name;
            const param = this.formItem.Related[item].param;
            const searchIndex = this.formItem.options.findIndex(
              (n) => n[this.formItem.value] === val
            );

            if (
              this.formOptions[param] &&
              this.formOptions[param].type == "Text"
            ) {
              this.formOptions[param].data =
                this.formItem.options[searchIndex][name];
              continue;
            }
            this.form[param] = this.formItem.options[searchIndex][name];
          }
        }
      }
      if (this.selectChange) {
        this.selectChange(val,paramkey);
      }
    },
    handleCh(list, name) {
      let title = "";
      _Cascader(list);
      return title;

      function _Cascader(list) {
        title = title ? list[name] + "/" + title : list[name];
        if (list.parent) {
          _Cascader(list.parent);
        }
      }
    },

    // 级联选择框 Change 事件
    handleChangeCascader(ref, v, i) {
      // 点击选中隐藏下拉选择矿
      if (!this.formItem.props?.multiple) {
        this.$refs[ref].dropDownVisible = false;
      }
      // const list = this.$refs[ref].getCheckedNodes()[0]
      // this.formItem.parentTitle = this.handleCh(list, 'label')
      const label_level = this.$refs[ref].getCheckedNodes()[0]
        ? this.$refs[ref].getCheckedNodes()[0]?.data.label_level
        : "";
      if (label_level == 3 && !this.formItem.props?.multiple) {
        this.$message("请选择工单标题");
        this.form[this.formItem.param] = [];
        this.$refs[ref].$refs.panel.clearCheckedNodes();
        this.$refs[ref].$refs.panel.activePath = [];

        return;
      }

      // this.formItem.key += 1

      if (this.formItem.Related) {
        if (v && v.length) {
          setTimeout(() => {
            this.$set(
              this.form,
              this.formItem.Related,
              this.$refs[ref].getCheckedNodes()[0]?.data[
                this.formItem.RelatedName
              ]
            );
          }, 10);
        } else {
          this.form[this.formItem.Related] = "";
        }
      }
      if (this.cascaderChange) {
        this.cascaderChange(v,i);
      }
    },
    handleSwitchRadio(data) {
      // this.form[this.formItem.param] = ''
    },
    // 获取Ocrtoken
    getOcrToken() {
      getOcr().then((res) => {
        this.ocrToken = res.data?.access_token;
      });
    },
    // 获取ossToken
    getOssToken() {
      getOss().then((res) => {
        const { accessid, host, signature, policy, dir } = JSON.parse(res.data);
        this.ossParms = {
          host: host,
          key: dir,
          OSSAccessKeyId: accessid,
          policy: policy,
          Signature: signature,
        };
      });
    },
    fileChange(type, info) {},
    get_suffix(filename) {
      const pos = filename.lastIndexOf(".");
      let suffix = "";
      if (pos !== -1) {
        suffix = filename.substring(pos);
      }
      return suffix;
    },
    imgUpload(params) {
      // 判断图片大小
      /*  if (params.file.size / 1024 / 1024 > 4) {
        this.$message('图片大小不能超过4M')
        return false
      } */
      const formData = new FormData();
      const fileName = `${this.ossParms.key}${curtime[0]}/${curtime[1]}/${
        curtime[2]
      }/${randomString(10)}${this.get_suffix(params.file.name)}`;
      const fileUrl = this.ossParms.host + "/" + fileName;
      formData.append("key", fileName);
      formData.append("OSSAccessKeyId", this.ossParms.OSSAccessKeyId);
      formData.append("policy", this.ossParms.policy);
      formData.append("Signature", this.ossParms.Signature);
      formData.append("file", params.file);
      formData.append("success_action_status", 200);
      axios.post(this.ossParms.host, formData).then((res) => {
        if (this.formItem.type === "Upload") {
          this.form[this.formItem.param] = fileUrl;
        } else {
          const list = fileUrl.split("/");
          this.form[this.formItem.param].push({
            name: list[list.length - 1],
            url: fileUrl,
          });
        }
      });
    },
    localImgUpload(file) {
      this.appealCmitDisabled = true;
      const fileObj = file.file;
      const param = new FormData();
      param.append("file_data", fileObj);
      param.append("extension", file.file.name.split(".")[1]);

      localUpload(param)
        .then((res) => {
          if (res.code == 10000) {
            const FileUrl = res.data.FileUrl;
            const list = FileUrl.split("/");
            this.form[this.formItem.param].push({
              name: list[list.length - 1],
              url: FileUrl,
            });
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${fileList.length} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    handleRestrictExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${formItem.limit} 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    handleRemoveImgList(file, fileList) {
      const uid = file.uid;
      const index = this.form[this.formItem.param].findIndex(
        (n) => n.uid === uid
      );
      this.form[this.formItem.param].splice(index, 1);
    },
    beforeAvatarUpload: function (file) {
      var isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        alert("上传图片大小不能超过10MB");
      }
    },
    // 图片限制及上传后获取路由
    handleRestrictUpload(params) {
      // 判断图片大小
      if (params.file.size / 1024 / 1024 > this.formItem?.size) {
        this.$message(`图片大小不能超过${this.formItem?.size}M`);
        return false;
      }
      const formData = new FormData();
      const fileName = `${this.ossParms.key}${this.$moment(
        new Date().getTime()
      ).format("YYYY/MM/DD")}/${params.file.name}`;
      const fileUrl = this.ossParms.host + "/" + fileName;
      formData.append("key", fileName);
      formData.append("OSSAccessKeyId", this.ossParms.OSSAccessKeyId);
      formData.append("policy", this.ossParms.policy);
      formData.append("Signature", this.ossParms.Signature);
      formData.append("file", params.file);
      formData.append("success_action_status", 200);
      axios.post(this.ossParms.host, formData).then((res) => {
        const list = fileUrl.split("/");
        this.form[this.formItem.param].push({
          name: list[list.length - 1],
          url: fileUrl,
        });
      });
    },
    //select框值改变时候触发的事件
    selectTreeChange(value) {
      var arrNew = [];
      var dataLength = this.treeValue?.length;
      var eleng = value?.length;
      for (let i = 0; i < dataLength; i++) {
        for (let j = 0; j < eleng; j++) {
          if (e[j] === this.treeValue[i].label || this.vlaue === e[j].id) {
            arrNew.push(this.treeValue[i]);
          }
        }
      }
      this.$refs.selectTree.setCheckedNodes(arrNew); //设置勾选的值
    },
    handleNodeClick(value) {
      if (!this.formItem.checkbox) {
        this.treeValue = [value];
        this.form[this.formItem.param] = value.name;
        this.form[this.formItem.value] = value.id;
        this.$refs.opt.select.blur();
      }
    },
    // 树形选择框带有复选框
    handleTreeCheckChange(ref, v) {
      let res = this.$refs.selectTree.getCheckedNodes();
      let arrLabel = [];
      let arr = [];
      res.forEach((item) => {
        arrLabel.push(item.name);
        arr.push(item.id);
      });
      this.treeValue = arr;
      this.form[this.formItem.param] = arrLabel;
    },
  },
};

/*

老mis后台上传参考

 uploadPhoto(file) {
      const fileObj = file.file
      const param = new FormData()
      param.append('photoData', fileObj)
      axios
        .post('/admin/v1/workOrderInfo/upload', param, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((res) => {
          // if (res.data.code == 10000) {
          //   this.photoUrls.push(res.data.message);
          //   this.photoUrlData.push(res.data.message);
          // }
          // this.workInfoParam.photos = this.photoUrlData.join(",");
        })
        .catch(function(err) {
        })
    }
    handleRemove(file, fileList) {
      this.photoUrlData = []
      for (let i = 0; i < fileList.length; i++) {
        // this.uploadImgs.push(fileList[i].raw);
        this.uploadPhotos(fileList[i].raw)
        // form[formItem.param]
      }
    },
    uploadPhotos: function(file) {
      const param = new FormData()
      param.append('photoData', file)
      axios
        .post('/api/workorderinfo/upload-photo', param, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((res) => {
          if (res.data.code == 10000) {
            this.photoUrls.push(res.data.message)
            this.photoUrlData.push(res.data.message)
          }
          this.workInfoParam.photos = this.photoUrlData.join(',')
        })
        .catch(function(err) {
        })
    } */
</script>

<style lang="scss" scoped>
.EleSection {
  width: 100%;
}
.InputTextView,
.Text {
  // flex: 1;
  display: flex;
  align-items: center;
  // flex: ;
  justify-content: space-between;
  .default {
    width: 100px;
    text-align: right;
  }
}

::v-deep .el-select,
.el-input,
.el-textarea,
.el-cascader,
.el-select {
  width: 100%;
}
.upload {
  display: flex;
  p {
    padding-left: 20px;
  }
}

.center {
  display: flex;
  justify-content: center;
  // align-self: center;
}
.el_content {
  display: flex;
  align-items: center;
}
.side_words {
  text-align: center;
  margin-left: -10%;
}
.divider {
  ::v-deep .el-divider--horizontal {
    justify-content: center;
    width: 88%;
  }
}
</style>
